'use client';

import React, { ReactNode, useState } from 'react';

import dynamic from 'next/dynamic';

import { Locale } from '@/i18n/config';
import { cn } from '@/utils/app.utils';

import { IMenu } from '@/types/app.type';

import Section from '../layouts/Section';
import NextIcon from '../NextIcon';
import TextLink from '../typography/TextLink';
import AnimatedHamburgerMenu from './AnimatedHamburgerMenu';
import Search from './Search';
import Logo from '../Logo';

// Client Components:
const NavBarMobileOpenMenu = dynamic(() => import('./NavBarMobileOpenMenu'), {
  ssr: false,
});

type Props = {
  menus: IMenu[];
  className?: string;
  toggleTheme: ReactNode;
  locale: Locale;
  tSearch: string;
  tNoResults: string;
};
const NavBarMobile = ({
  menus,
  className,
  toggleTheme,
  locale,
  tSearch,
  tNoResults,
}: Props) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [openSearchInput, setSearchInput] = useState(false);

  const toggleMenu = () => setOpenMenu(prev => !prev);
  const toggleSearchInput = () => setSearchInput(prev => !prev);

  return (
    <nav
      className={cn(
        'z-50 flex h-[55px] flex-col justify-center bg-white dark:bg-neutral-900 lg:hidden',
        openMenu ? 'fixed left-0 right-0 top-0 h-[55px]' : '',
        className
      )}
    >
      <Section className="flex flex-row items-center justify-between self-stretch">
        {openSearchInput ? (
          <div className="relative flex flex-1 flex-row items-center self-stretch">
            <Search
              className="max-w-none"
              inputClassName="border-none px-0 pl-7"
              locale={locale}
              // searchIconClassName="left-0"
              tNoResults={tNoResults}
              tSearch={tSearch}
            />
            <button
              className="absolute right-0 flex h-full flex-col justify-center self-stretch"
              type="button"
              onClick={toggleSearchInput}
            >
              <NextIcon size={20} src="/icons/x.svg" />
            </button>
          </div>
        ) : (
          <>
            <div className="flex1 flex flex-row items-center">
              <TextLink href="/">
                {/* <LogoSVGMobile /> */}
                <Logo width={75} />
              </TextLink>
            </div>
            <div className="flex flex-row justify-between space-x-4">
              <button
                className="align-center m-r-10 flex flex-col justify-center self-stretch"
                type="button"
                onClick={toggleSearchInput}
              >
                <NextIcon
                  className="block dark:hidden"
                  size={20}
                  src="/icons/search2.svg"
                />
                <NextIcon
                  className="hidden dark:block"
                  size={20}
                  src="/icons/search2-dark.svg"
                />
              </button>
              <button
                className="align-center flex flex-col justify-center self-stretch"
                type="button"
                onClick={toggleMenu}
              >
                <AnimatedHamburgerMenu open={openMenu} />
              </button>
            </div>
            <NavBarMobileOpenMenu
              menus={menus}
              openMenu={openMenu}
              toggleMenu={toggleMenu}
              toggleTheme={toggleTheme}
            />
          </>
        )}
      </Section>
    </nav>
  );
};

export default NavBarMobile;
